import { ThemeProvider, createTheme } from "@mui/material/styles";
import { createContext, useMemo, useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { useMediaQuery } from "@mui/material";
import { getDesignTokens } from "./getDesignTokens";

export const ColorModeContext = createContext({ toggleColorMode: () => {} });

const Theme = ({ children }) => {
  const [userThemePref, setUserThemePref] = useState(
    localStorage.getItem("user_theme_preference") || "dark"
  );
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const colorMode = useMemo(
    () => ({
      toggleColorMode: (newPref) => {
        setUserThemePref(newPref);
        localStorage.setItem("user_theme_preference", newPref);
      },
    }),
    []
  );

  const mode = useMemo(() => {
    let res;

    if (userThemePref === "system") {
      res = prefersDarkMode ? "dark" : "light";
    } else {
      res = userThemePref;
    }

    return res;
  }, [userThemePref, prefersDarkMode]);

  const theme = useMemo(() => {
    let themeReady = createTheme(getDesignTokens(mode));
    // themeReady = responsiveFontSizes(themeReady);
    return themeReady;
  }, [mode]);

  document.querySelector("meta[name='theme-color']").content =
    theme.palette.background.default;

  const htmlElement = document.documentElement;
  htmlElement.setAttribute("data-theme", mode);

  const bodyElement = document.body;
  // bodyElement.className = `scrollbar-${mode}` // peut causer des bugs si MUI ajoute/enlève des classes

  // Ce code est plus sur
  const darkClass = "scrollbar-dark";
  const lightClass = "scrollbar-light";

  if (mode === "dark") {
    bodyElement.classList.add(darkClass);
    bodyElement.classList.remove(lightClass);
  } else {
    bodyElement.classList.add(lightClass);
    bodyElement.classList.remove(darkClass);
  }

  return (
    <ColorModeContext.Provider value={{ colorMode, userThemePref }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default Theme;
